import request from 'assets/js/http';

export function financeVoteList(data) {
  // 待创建贡献表列表
  return request({
    url: '/financeVote/list',
    method: 'post',
    data
  });
}
